import { MetaMaskInpageProvider } from '@metamask/providers';
import { Maybe } from '#/utils/types';

export interface EthereumProviderRpcError extends Error {
  readonly code: number;
  readonly data?: unknown;
}

/**
 * Retrieve ethereum provider or undefined.
 * To be used where we want handle Eth Provider missing gracefully (e.g. suggest to install MetaMask)
 */
export function getMaybeEthereum(): Maybe<MetaMaskInpageProvider> {
  return window.ethereum;
}

export function getRpcError(err: unknown): EthereumProviderRpcError | null {
  if (err == null) throw new TypeError('Unexpected null or undefined');
  return (err as { code?: number }).code !== undefined
    ? (err as EthereumProviderRpcError)
    : null;
}

interface PreparedErrorMessage {
  message: string;
  isException: boolean;
}

export function prepareErrorMessage(
  step: string,
  err: unknown,
): PreparedErrorMessage {
  const rpcErrorMessage = getRpcError(err)?.message;
  const isException = rpcErrorMessage == null;
  const reason = rpcErrorMessage ?? (err as Maybe<Error>)?.message ?? err;
  const message = `${step}: ${String(reason)}`;

  return { message, isException };
}
